function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Component } from 'react';
import PropTypes from 'prop-types';
import { FelaThemeFactory, THEME_CHANNEL } from 'fela-bindings';

export default FelaThemeFactory(Component, _defineProperty({}, THEME_CHANNEL, PropTypes.object));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/node_modules/react-fela/es/FelaTheme.js
// module id = 357
// module chunks = 0